import Vue, { PluginFunction } from 'vue';
import 'chartist/dist/chartist.min.css';
import chartist from 'vue-chartist';

Vue.use(chartist as PluginFunction<any>, {
  messageNoData: 'Brak danych',
  classNoData: 'ct-nodata'
});
